/*
 * Magnific popup
 */

$('.js-mfp-close').on('click', function (event) {
  event.preventDefault();
  var magnificPopup = $.magnificPopup.instance;
  magnificPopup.close();
});
